import React from 'react';
import { Modal } from 'react-bootstrap';
import Add_Dmvic_Underwritter from '../forms/setup/Add_Dmvic_Underwritter';
import Add_Rate from '../forms/setup/Add_Rate';

function AddRate(props) {
    return (
   <div>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Rate</h5> 
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Add_Rate  {...props}/>
        </Modal.Body>
      </Modal>
    </div>
    );
}

export default AddRate;